import { TZDate } from '@date-fns/tz';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

export const WEEK_DAY_NAMES = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

export const toTzDate = (date, timezone) =>
  new TZDate(date.toISOString(), timezone);

export const formatDateKey = (date, timezone) =>
  format(toTzDate(date, timezone), 'yyyy-MM-dd', { locale: ru });
